import { render, staticRenderFns } from "./PropertiesForm.vue?vue&type=template&id=7821d294&scoped=true"
import script from "./PropertiesForm.vue?vue&type=script&lang=js"
export * from "./PropertiesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7821d294",
  null
  
)

export default component.exports